module.exports = __webpack_public_path__ + "static/img/Simulations 3 - Spacecraft Design Analysis.ef5cb6c.png";